"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const FacebookFillSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 2.6665C8.63602 2.6665 2.66669 8.63584 2.66669 15.9998C2.66669 22.6545 7.54269 28.1705 13.9174 29.1718V19.8532H10.5307V15.9998H13.9174V13.0625C13.9174 9.72117 15.9067 7.87584 18.9534 7.87584C20.412 7.87584 21.9374 8.13584 21.9374 8.13584V11.4158H20.2574C18.6 11.4158 18.084 12.4438 18.084 13.4985V15.9998H21.7814L21.1907 19.8532H18.084V29.1718C24.4574 28.1718 29.3334 22.6532 29.3334 15.9998C29.3334 8.63584 23.364 2.6665 16 2.6665Z" fill="#1877F2" />
  </svg>
)


const FacebookFillIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={FacebookFillSvg} {...props} />
);

export default FacebookFillIcon